import { Plugin, PluginKey } from '@tiptap/pm/state';
import CodeBlockLowLight from '@tiptap/extension-code-block-lowlight';

const CustomCodeBlockLowLight = CodeBlockLowLight.extend({
  content: '(text|mention?)*',
  name: 'CustomCodeBlockLowLight',
  addAttributes() {
    return {
      ...this.parent?.(),
      spellcheck: {
        default: false,
        parseHTML: element => element.getAttribute('spellcheck'),
        renderHTML: attributes => {
          return {
            spellcheck: attributes.spellcheck,
          };
        },
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      'Shift-Mod-c': ({ editor }) => editor.commands.toggleCodeBlock(),
      Enter: ({ editor }) => {
        const { state } = editor;
        const { selection } = state;
        const { $from, empty } = selection;

        // compare the selected node type against the node type 'codeBlock'
        if (
          $from.node().type === this.type &&
          !editor.commands.isSuggestionActive?.()
        ) {
          return editor.commands.exitCode();
        }
        return false;
      },
    };
  },
});

export default CustomCodeBlockLowLight;
